// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2iYr_","actions":"GroupTable_actions__2fUH3","deleteModalFooter":"GroupTable_deleteModalFooter__2E8_S"};